'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

import { Icon } from '@/app/components/Icon'
import { cn } from '@/app/utils/style'
import { getLocaleFromPathname } from '@/lib/i18n'

export const LanguageSelector = function () {
  const pathname = usePathname()
  const locale = getLocaleFromPathname(pathname)

  // Hide language selector if Spanish is disabled
  const disableSpanish = process.env.NEXT_PUBLIC_DISABLE_ES_FRONTEND === 'true'
  if (disableSpanish) {
    return null
  }

  return (
    <div className="flex flex-row items-center gap-sm h-lg">
      <Icon name="faGlobe" provider="fontawesome" style="regular" size={16} />
      <Link
        href="/"
        className={cn(
          'size-overline-sm leading-overline-sm tracking-overline-sm font-black uppercase transition-colors duration-250',
          locale === 'en'
            ? 'text-primary-600'
            : 'text-neutral-900 hover:text-primary-600 active:text-primary-200',
        )}
      >
        EN
      </Link>
      <div className="w-[2px] h-[14px] bg-primary-200 my-[1px]" />
      <Link
        href="/es"
        className={cn(
          'size-overline-sm leading-overline-sm tracking-overline-sm font-black uppercase transition-colors duration-250',
          locale === 'es'
            ? 'text-primary-600'
            : 'text-neutral-900 hover:text-primary-600 active:text-primary-200',
        )}
      >
        ES
      </Link>
    </div>
  )
}
